import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ResumeBuilder from './pages/ResumeBuilder';
import LandingPage from './pages/LandingPage';
import ResumePreviewLayout from './components/ResumePreviewLayout';
import SelectTemplate from './pages/SelectTemplate';
import ResumePreview from './components/ResumePreview';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import { Analytics } from "@vercel/analytics/react"
function App() {
  return (
    <Router>
      <Routes>
      <Route path='/' element={<LandingPage />} />
      <Route path='/signin' element={<Signin />} />
      <Route path='/signup' element={<Signup />} />
      <Route path="/resume-builder" element={<ResumeBuilder />} />
      <Route path="/resume-preview-layout" element={<ResumePreviewLayout />} />
      <Route path="/resume-preview/:id" element={<ResumePreview />} />
      <Route path="/select-template" element={<SelectTemplate />} />

      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
